import { DuplicateIcon, MinusCircleIcon } from '@heroicons/react/solid';
import { addMinutes, differenceInMinutes, format, getISODay, parse, setDay, setISODay } from 'date-fns';
import { useState, useEffect, Fragment } from 'react';
import { Input, Label } from '../Field';

function ScheduleTab({ schedule = [], t }) {
    const [dataset, setDataset] = useState(Array.from(Array(7), () => []));
    const [slots, setSlots] = useState([]);

    const changeHandler = (weekday, index, field, value) => {
        setDataset((oldValue) => {
            const newValue = oldValue.map((weekday) => [...weekday]);
            newValue[weekday][index][field] = value;
            return newValue;
        });
    };

    const removeHandler = (weekday, index) => {
        setDataset((oldValue) => {
            const newValue = oldValue.map((weekday) => [...weekday]);
            newValue[weekday].splice(index, 1);
            return newValue;
        });
    };

    const addHandler = (weekday) => {
        setDataset((oldValue) => {
            const newValue = oldValue.map((weekday) => [...weekday]);
            newValue[weekday].push({
                start: '',
                end: '',
            });
            return newValue;
        });
    };

    const replicateMonday = () => {
        setDataset((oldValue) => {
            const newValue = oldValue.map((weekday) => [...weekday]);
            for (let i = 1; i <= 6; i++) {
                newValue[i] = JSON.parse(JSON.stringify(newValue[0]));
            }
            return newValue;
        });
    };

    useEffect(() => {
        setDataset((oldValue) => {
            const newValue = oldValue.map((slots) => [...slots]);
            schedule.forEach(({ start, duration }) => {
                start = new Date(start);
                const weekday = getISODay(start);
                const end = addMinutes(start, duration);
                newValue[weekday - 1].push({
                    start: format(start, 'HH:mm'),
                    end: format(end, 'HH:mm'),
                });
            });
            return newValue;
        });
    }, []);

    useEffect(() => {
        setSlots(
            dataset
                .map((entries, index) =>
                    entries
                        .filter(({ start, end }) => start && end)
                        .map(({ start, end }) => {
                            const weekday = index + 1;
                            start = parse(start, 'HH:mm', setISODay(new Date(), weekday));
                            end = parse(end, 'HH:mm', setISODay(new Date(), weekday));

                            return {
                                start: start.toISOString(),
                                duration: differenceInMinutes(end, start),
                            };
                        })
                )
                .flat()
        );
    }, [dataset]);

    return (
        <>
            <table>
                <tbody>
                    {dataset.map((hours, weekday) => (
                        <tr key={weekday}>
                            <td className="flex items-center gap-2 pr-8 capitalize align-top">
                                <Label>{format(setDay(new Date(), weekday + 1), 'iiii', { locale: window.dateLocale })}</Label>
                                {weekday == 0 && (
                                    <button type="button" title={t('clone-schedule')} onClick={replicateMonday}>
                                        <DuplicateIcon className="h-4 text-gray-400 hover:text-gray-600" />
                                    </button>
                                )}
                            </td>
                            <td className="pb-4">
                                <div className="space-y-1">
                                    {hours.map((entry, index) => (
                                        <div key={index} className="flex items-center gap-1">
                                            <Input
                                                type="time"
                                                className="py-1 text-xs"
                                                value={entry.start}
                                                onChange={(e) => {
                                                    changeHandler(weekday, index, 'start', e.target.value);
                                                }}
                                                required
                                            />
                                            <Input
                                                type="time"
                                                className="py-1 text-xs"
                                                value={entry.end}
                                                onChange={(e) => {
                                                    changeHandler(weekday, index, 'end', e.target.value);
                                                }}
                                                required
                                            />
                                            <button
                                                onClick={() => {
                                                    removeHandler(weekday, index);
                                                }}
                                                type="button"
                                                className="flex-none ml-2 text-gray-400 hover:text-gray-700"
                                            >
                                                <MinusCircleIcon className="w-5 h-5" />
                                            </button>
                                        </div>
                                    ))}
                                </div>
                                <button
                                    onClick={() => {
                                        addHandler(weekday);
                                    }}
                                    type="button"
                                    className="text-xs text-gray-500 hover:text-gray-800"
                                >
                                    + {t('add-schedule')}
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {slots.length == 0 && <input type="hidden" name={`schedule[]`} />}
            {slots.map(({ start, duration }, index) => (
                <Fragment key={index}>
                    <input type="hidden" name={`schedule[${index}][start]`} value={start} />
                    <input type="hidden" name={`schedule[${index}][duration]`} value={duration} />
                </Fragment>
            ))}
        </>
    );
}

export default ScheduleTab;
